import script from "./Table_InDel.vue?vue&type=script&setup=true&lang=js"
export * from "./Table_InDel.vue?vue&type=script&setup=true&lang=js"

import "./Table_InDel.vue?vue&type=style&index=0&id=965e357e&lang=css"

const __exports__ = script;

export default __exports__